import React from 'react';
import { Navigate } from 'react-router-dom';
import { auth } from '../services/auth';

/**
 * Redirects to /overview when the current session lacks any required role.
 */
const RequireRole = ({ roles = [], children, redirectTo = '/overview' }) => {
  const required = Array.isArray(roles) ? roles : [roles];
  const allowed = required.length === 0 || required.some((role) => auth.hasRole(role));
  if (!allowed) {
    return <Navigate to={redirectTo} replace />;
  }
  return children;
};

export default RequireRole;
